import { useVuetify } from 'ui-common'

export default useVuetify()
